import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './CenterCard.module.css';

/**
 * EAA-1778: the shared centered-card shell for the full-screen transient states
 * — login redirect, OIDC callback, and config boot. Pure presentation, no
 * context (ConfigProvider renders it before any provider exists). A spinner
 * shows by default; `prefers-reduced-motion` freezes it via global.css.
 */
export function CenterCard({
    title,
    children,
    showSpinner = true,
}: {
    title: string;
    children?: ReactNode;
    showSpinner?: boolean;
}) {
    const { t } = useTranslation();
    return (
        <div className="portal-center">
            <div className="portal-center-card">
                <span className="portal-appbar-mark" aria-hidden="true">
                    {t('shell.brand.mark')}
                </span>
                {showSpinner && (
                    <div
                        className={styles.spinner}
                        role="status"
                        aria-label={t('shell.centerCard.processingLabel')}
                    />
                )}
                <h1 className={styles.title}>{title}</h1>
                {children}
            </div>
        </div>
    );
}
